import React from 'react';
import styled from 'styled-components';
import Results from './../Results';

const Wrapper = styled.div`

`;

const ResultPage = (props) => {
	const resultSchema = {
		youBusiness: {
			industry: {
				name: 'industry',
				label: 'Industry sector:'
			},
			numberOfEmployees: {
				name: 'numberOfEmployees',
				label: 'Number of employees:'
			},
			averageSalary: {
				name: 'averageSalary',
				label: 'Average employee salary:',
				type: 'currency'
			},
			averageOfWorkingDay: {
				name: 'averageOfWorkingDay',
				label: 'Average annual number of working days lost due to absenteeism per employee:'
			}
		},
		directCost: {
			averageCostPerYear: {
				name: 'averageCostPerYear',
				label: 'The average cost of absenteeism per employee per year:',
				type: 'currency'
			},
			averageCostPerDay: {
				name: 'averageCostPerDay',
				label: 'The average cost of absenteeism per employee per day:',
				type: 'currency'
			},
			totalCostPerDay: {
				name: 'totalCostPerDay',
				label: 'The total cost of absenteeism to the business per year:',
				type: 'currency'
			}
		},
		savings: {
			annualSaving: {
				name: 'annualSaving',
				label: `By reducing absenteeism by ${props.data.totalCostPerDay}% your reduction in direct costs of absenteeism could be:`,
				type: 'currency'
			}
		}
	};
	const resultsList = [
		{ title: 'Your business', results: props.data, name: 'youBusiness' },
		{ title: 'The direct cost of absenteeism to your business', results: props.results, name: 'directCost' },
		{ title: 'The potential savings for your business', results: props.results, name: 'savings'}
	];
	return (
		<Wrapper>
			{
				resultsList.map(({ title, results, name }, index) => (
					<Results key={index} {...{ results, title, schema: resultSchema[name] }} />
				))
			}
		</Wrapper>
	);
};

export default ResultPage;



// WEBPACK FOOTER //
// ./src/html/components/ResultPage/ResultPage.js